import React, { memo } from 'react';
import { Handle, Position } from 'react-flow-renderer';

const FaqNode = ({ data, isConnectable }) => {
  return (
    <div className="node node-faq">
      <Handle type="target" position={Position.Top} isConnectable={isConnectable} />
      <div>
        <h4>{data.label}</h4>
        <p>FAQ Handler</p>
        {data.language && <p>Language: {data.language}</p>}
      </div>
      <Handle type="source" position={Position.Bottom} isConnectable={isConnectable} />
    </div>
  );
};

export default memo(FaqNode);
